<template>
  <a-modal
    title="开通支付宝酒店"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('close')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="shopForm"
      :model="shopForm"
      :rules="shopFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="支付宝酒店名称" prop="zfbHotelProjectName">
        <a-input v-model="shopForm.zfbHotelProjectName" placeholder="请填写" />
      </a-form-model-item>

      <a-form-model-item label="所属行业" prop="industryId">
        <a-select v-model="shopForm.industryId" placeholder="请选择">
          <a-select-option v-for="(item,index) in industryList " :key="index" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否测试项目" prop="zfbHotelIsTest">
        <a-radio-group v-model="shopForm.zfbHotelIsTest" :default-value="false">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="业务平台" prop="appId">
        <a-select v-model="shopForm.appId" placeholder="请选择">
          <a-select-option v-for="(item,index) in appList " :key="index" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否订阅" prop="isSubscribe">
        <a-radio-group v-model="shopForm.isSubscribe">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import store from '@/store'
import { QueryIndustrySimplifyList } from '@/apis/industry'
import {AppIndex} from "@/apis/app";

const enumsData = store.state.enumsStore.enumsData

const shopForm = {
  id: undefined,
  industryId: undefined,
  state: 0,
  zfbHotelIsTest: undefined,
  zfbHotelProjectName: undefined,
  appId: undefined,
  isSubscribe: true
}

const shopFormRules = {
  id: [{ required: true, message: '请选择鱼住门店！' }],
  industryId: [{ required: true, message: '请选择行业！' }],
  zfbHotelIsTest: [{ required: true, message: '请选择是否测试项目！' }],
  zfbHotelProjectName: [{ required: true, message: '请填写支付宝酒店名称！' }],
  appId: [{ required: false, message: '请选择业务平台！' }],
  isSubscribe: [{ required: false, message: '请选择是否订阅！' }],
}

export default {
  name: 'HotelCreateModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    },
    name: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      shopForm,
      shopFormRules,
      adcOptions:[],
      templateList:[],
      industryList:[],
      appList:[],
      uploading: false,
      confirmLoading:false,
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          let { id }= this.obj
          this.shopForm.id = id
          this.shopForm.zfbHotelIsTest = false
          this.shopForm.zfbHotelProjectName = this.name
        })
      }
    }
  },

  created() {
    this.handleGetIndustryList()
    this.getAppList()
  },
  methods: {
    // 提交模态框数据
    getAppList(){
      AppIndex({page: 1, perPage: 100}).then(res=>{
        if (res.code === 0){
          this.appList = res.collection
        }
      })
    },
    handlerSubmit() {
      this.$refs.shopForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.shopForm)
          this.confirmLoading = true
        }
      })
    },
    handleGetIndustryList(){
      let _this = this
      QueryIndustrySimplifyList().then(res=>{
        _this.industryList = res.collection
      })
    },
    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.shopForm.resetFields()
      this.shopForm = shopForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
